import { TransFixDto } from 'app/admin/workflow/component/items/TransformationProperties';
import ModelEditDto from 'app/admin/model/dto/ModelEditDto';
import WorkflowModelInputAttributeEditDto from './WorkflowModelInputAttributeEditDto';
import WorkflowModelOutputAttributeEditDto from './WorkflowModelOutputAttributeEditDto';

export class WorkflowModelEditDto extends ModelEditDto {
	constructor() {
		super();
		/** @type {WorkflowModelInputAttributeEditDto[]} */
		this.inputAttributes = null;
		/** @type {WorkflowModelOutputAttributeEditDto[]} */
		this.outputAttributes = null;
		/** @type {string} */
		this.json = null;
		/** @type {string} */
		this.export = null;
		/** @type {string} */
		this.transformations = null;
		/** @type {string} */
		this.state_file = null;
	}

	/**
	 * @typedef {Object} _WorkflowModelEditDtoProps
	 * @property {WorkflowModelInputAttributeEditDto[]} inputAttributes
	 * @property {WorkflowModelOutputAttributeEditDto[]} outputAttributes
	 * @property {string} json
	 * @property {string} export
	 * @property {string} transformations
	 * @property {string} state_file
	 *
	 * @typedef {import("app/admin/model/dto/ModelEditDto").ModelEditDtoProps & _WorkflowModelEditDtoProps} WorkflowModelEditDtoProps
	 */
	/**
	 *
	 * @param {WorkflowModelEditDtoProps} props
	 * @returns {WorkflowModelEditDto}
	 */
	setup(props) {
		super.setup(props);
		TransFixDto(props);
		this.inputAttributes = props.inputAttributes !== null ? props.inputAttributes.map(d => new WorkflowModelInputAttributeEditDto().setup(d)) : [];
		this.outputAttributes = props.outputAttributes !== null ? props.outputAttributes.map(d => new WorkflowModelOutputAttributeEditDto().setup(d)) : [];
		this.json = props.json;
		this.export = props.export;
		this.transformations = props.transformations;
		this.state_file = props.state_file;
		return this;
	}
}

export default WorkflowModelEditDto;
